import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

// <!--Add Axios, https://medium.com/spemer/using-axios-in-vue-js-17f186756a8b-->

const state = {
    currentCustomer: {},
    currentPartner: {},
};

export default {
    state,
    getters,
    actions,
    mutations,
};
